import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "container overflow-hidden h-full v-full"
};
const _hoisted_2 = {
  class: "ma-2 flex items-center gap-2"
};
const _hoisted_3 = {
  key: 2,
  class: "container overflow-hidden h-full v-full"
};
const _hoisted_4 = {
  class: "h-full v-full at-luzmo"
};
const _hoisted_5 = {
  key: 3,
  class: "h-full flex flex-col"
};
const _hoisted_6 = {
  key: 4,
  class: "container overflow-hidden h-full v-full"
};
const _hoisted_7 = {
  class: "h-full v-full at-luzmo"
};
import { watchEffect, onMounted, reactive, ref, computed, watch, nextTick } from 'vue';
import { useEmbeddedReportStore } from './../reports/dashboard/useEmbeddedReportStore.js';
import Loader from '@/components/Loader.vue';
import MetabaseDashboard from '@/components/MetabaseDashboard.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import EventTracker from '@/services/eventTracker';
const appServer = 'https://app.us.luzmo.com/';
const apiHost = 'https://api.us.luzmo.com/';
export default {
  __name: 'InsightsHome',
  props: {
    alerts: {
      type: Object,
      required: false
    },
    reportState: {
      type: Object,
      required: false
    },
    routeService: {
      type: Object,
      required: false
    },
    timeFilters: {
      type: Object,
      required: false
    },
    tracking: {
      type: Object,
      required: false
    }
  },
  setup(__props) {
    const props = __props;
    const insightState = reactive({
      loading: false,
      saving: false,
      warning: false,
      keys: {},
      dashboardId: '',
      luzmoDashboardId: '',
      editMode: '',
      isTimeEntryPage: false,
      newTimePage: false,
      timeEntryDashboardId: '',
      provider: '' // 'metabase' | 'luzmo' | ''
    });
    const currentUrl = ref(window.location.href);
    const dashboardInstance = ref();
    const entriesFilter = ref({});
    const embeddedReportStore = useEmbeddedReportStore();
    embeddedReportStore.alerts = props.alerts;
    const params = computed(() => {
      if (insightState.newTimePage) {
        return {
          account: props.timeFilters?.account?.id,
          matterId: props.timeFilters?.cm?.matter?.id,
          clientId: props.timeFilters?.cm?.client?.id,
          billedState: props.timeFilters?.billed?.id,
          startDate: props.timeFilters?.range?.range?.startDate ? new Date(props.timeFilters.range.range.startDate).toNetworkDate() : null,
          endDate: props.timeFilters?.range?.range?.endDate ? new Date(new Date(props.timeFilters.range.range.endDate).getTime() + 24 * 60 * 60 * 1000).toNetworkDate() : null,
          timeOffset: new Date().getTimezoneOffset(),
          activity: props.timeFilters?.codes?.activity?.id,
          task: props.timeFilters?.codes?.task?.id
        };
      } else {
        return {
          account: entriesFilter.value?.account?.id,
          matterId: entriesFilter.value?.matter?.id,
          clientId: entriesFilter.value?.client?.id,
          billedState: entriesFilter.value?.billed?.id,
          startDate: entriesFilter.value?.period?.range?.startDate ? new Date(entriesFilter.value.period.range.startDate).toNetworkDate() : null,
          endDate: entriesFilter.value?.period?.range?.endDate ? new Date(new Date(entriesFilter.value.period.range.endDate).getTime() + 24 * 60 * 60 * 1000).toNetworkDate() : null,
          timeOffset: new Date().getTimezoneOffset(),
          activity: entriesFilter.value?.codes?.activity?.id,
          task: entriesFilter.value?.codes?.task?.id
        };
      }
    });
    const metabaseFilters = computed(() => ({
      UserId: params.value.account,
      MatterId: params.value.matterId,
      ClientId: params.value.clientId,
      Billed: metabaseBilledFilter(params.value.billedState),
      StartDate: params.value.startDate,
      EndDate: subtractOneDay(params.value.endDate),
      ActivityCode: params.value.activity,
      TaskCode: params.value.task
    }));
    function subtractOneDay(dateString) {
      // leanlaw native reports and luzmo have enddate as the day AFTER the time period, so adjusting back one day for metabase
      const date = new Date(dateString + 'T00:00:00Z');
      date.setDate(date.getDate() - 1);
      return date.toISOString().slice(0, 10);
    }
    function metabaseBilledFilter(billedState) {
      if (billedState === 'notFinal') return 'wip,interim';
      if (billedState === 'all') return null;
      return billedState;
    }
    const canViewOldVersion = computed(() => {
      return !insightState.isTimeEntryPage && insightState.provider === 'metabase' && !!insightState.luzmoDashboardId;
    });
    const viewOldVersion = () => {
      if (!insightState.luzmoDashboardId) {
        return;
      }
      insightState.provider = 'luzmo';
      insightState.dashboardId = insightState.luzmoDashboardId;
      insightState.warning = true;
      if (props.reportState) {
        props.reportState.dashboardProvider = 'luzmo';
        props.reportState.dashboardId = insightState.luzmoDashboardId;
      }
      EventTracker.trackEvent(props.tracking, 'Report', 'Reverted', {
        dashboardId: insightState.luzmoDashboardId
      });
    };

    // Consolidated method for handling time entry dashboard setup and data loading
    const setupTimeEntryDashboard = async parameters => {
      // Resolve provider once per navigation (result is cached in the store)
      if (!insightState.provider) {
        const resolved = await embeddedReportStore.resolveDashboardByTag('reportstime');
        if (!resolved) return; // Shouldn't happen, but can in principle if metabase dashboard isn't found
        insightState.provider = resolved.provider;
        insightState.timeEntryDashboardId = resolved.dashboardId;
      }
      if (insightState.provider === 'metabase') {
        return; // MetabaseDashboard component handles its own loading and filter updates
      }

      // // Luzmo flow below
      // // Ensure we have the timeEntryDashboardId set
      // if (!insightState.timeEntryDashboardId) {
      //   const timeEntryDashboardId =
      //     localStorage.getItem('timeEntryDashboardId') ||
      //     embeddedReportStore.getTimeEntryDefaultDashboardId();

      //   if (!timeEntryDashboardId) {
      //     // Need to load dashboards first to get the default time entry dashboard ID
      //     await embeddedReportStore.listDashboard();
      //     const defaultTimeEntryDashboardId =
      //       embeddedReportStore.getTimeEntryDefaultDashboardId();
      //     if (defaultTimeEntryDashboardId) {
      //       localStorage.setItem(
      //         'timeEntryDashboardId',
      //         defaultTimeEntryDashboardId,
      //       );
      //       insightState.timeEntryDashboardId = defaultTimeEntryDashboardId;
      //     }
      //   } else {
      //     insightState.timeEntryDashboardId = timeEntryDashboardId;
      //   }
      // }

      // if (insightState.timeEntryDashboardId) {
      //   // Get the embedded time entry reports data
      //   const response = await embeddedReportStore.getEmbeddedTimeEntryReports(
      //     parameters,
      //   );

      //   if (response.data.authKey && response.data.authToken) {
      //     // Update the state first so the component can render
      //     insightState.keys = response.data;

      //     // Wait for template to render
      //     await nextTick();

      //     // Setup dashboard authorization with retry logic
      //     const setupDashboardAuth = async () => {
      //       if (dashboardInstance.value) {
      //         try {
      //           await dashboardInstance.value.setAuthorization(
      //             response.data.authKey,
      //             response.data.authToken,
      //           );
      //           await dashboardInstance.value.reloadDashboard();
      //         } catch (error) {
      //           props.alerts.error(error.response.data.message);
      //         }
      //       } else {
      //         await nextTick();
      //         // Try again after a short delay
      //         setTimeout(async () => {
      //           await nextTick();
      //           if (dashboardInstance.value) {
      //             try {
      //               await dashboardInstance.value.setAuthorization(
      //                 response.data.authKey,
      //                 response.data.authToken,
      //               );
      //               await dashboardInstance.value.reloadDashboard();
      //             } catch (error) {
      //               props.alerts.error(error.response.data.message);
      //             }
      //           }
      //         }, 100);
      //       }
      //     };

      //     await setupDashboardAuth();
      //   } else {
      //     props.alerts?.error('Dashboard authorization failed');
      //   }
      // }
    };
    watch(params, async newParams => {
      if (insightState.isTimeEntryPage) {
        await setupTimeEntryDashboard(newParams);
      }
    }, {
      immediate: true
    });
    watchEffect(() => {
      if (props.reportState?.dashboardId && embeddedReportStore.deleted) {
        insightState.dashboardId = embeddedReportStore.getDefaultDashboardId();
        embeddedReportStore.deleted = false;
        return;
      }
      if (props.reportState?.upgradeToProDashboardId) {
        insightState.dashboardId = props.reportState.upgradeToProDashboardId;
        return;
      }
      if (props.reportState?.dashboardId) {
        insightState.dashboardId = props.reportState.dashboardId;
        insightState.editMode = props.reportState.editMode;
        insightState.provider = props.reportState.dashboardProvider || 'luzmo';
        insightState.luzmoDashboardId = props.reportState.luzmoDashboardId || '';
        console.log('[InsightsHome] Dashboard changed:', {
          dashboardId: insightState.dashboardId,
          provider: insightState.provider,
          fromReportState: props.reportState.dashboardProvider
        });
      }
      currentUrl.value = window.location.href;
      // Check if we're on a time entries page
      const isOnTimeEntryPage = currentUrl.value.includes('timeentries') || currentUrl.value.includes('time');
      if (isOnTimeEntryPage) {
        insightState.isTimeEntryPage = true;
        entriesFilter.value = JSON.parse(localStorage.getItem('entriesFilter'));
        if (currentUrl.value.includes('time') && props.timeFilters) {
          insightState.newTimePage = true;
        }
      } else {
        // Reset time entry state when navigating away
        insightState.isTimeEntryPage = false;
        insightState.newTimePage = false;
        insightState.timeEntryDashboardId = '';
      }
      insightState.editMode = props.reportState?.editMode;
    });
    onMounted(async () => {
      if (insightState.isTimeEntryPage) {
        await setupTimeEntryDashboard(params.value);
        return;
      }
      insightState.loading = true;

      // Don't set default dashboard if reportState already has one (e.g., from clicking an advanced report)
      if (!props.reportState?.dashboardId) {
        insightState.dashboardId = embeddedReportStore.getDefaultDashboardId();
      }

      // await embeddedReportStore.getEmbeddedReports();
      // await embeddedReportStore.listDashboard();
      embeddedReportStore.getTimeEntryDefaultDashboardId();
      insightState.keys = embeddedReportStore.keys;
      insightState.loading = false;
    });
    const updateDashboardTitle = async event => {
      const newDashboard = {
        label: event.data?.updatedTitle?.en,
        dateRangeOptions: false,
        embedded: true,
        embeddedCustomReport: true,
        showReport: true,
        reportType: event.data?.dashboardId,
        dashboardId: event.data?.dashboardId,
        id: event.data?.dashboardId,
        name: event.data?.updatedTitle?.en
      };
      if (event && event.data?.action === 'updateDashboardTitle') {
        const index = embeddedReportStore.customReportList.findIndex(item => item.id === event.data?.dashboardId);
        embeddedReportStore.customReportList.splice(index, 1, newDashboard);
      } else if (event && event.data?.action === 'dashboardSaved') {
        embeddedReportStore.customReportList.push(newDashboard);
      }
    };
    return (_ctx, _cache) => {
      const _component_v_alert = _resolveComponent("v-alert");
      const _component_luzmo_dashboard = _resolveComponent("luzmo-dashboard");
      return insightState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Reports Dashboard',
        class: "mt-32 at-loader"
      })) : !insightState.isTimeEntryPage && insightState.provider === 'metabase' && insightState.dashboardId ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_v_alert, {
        type: "info",
        variant: "tonal",
        density: "compact",
        "onClick:close": _ctx.dismissBanner,
        class: "text-sm flex-1"
      }, {
        text: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" This report was updated to a new version for better performance and visuals. If there are any issues or if you have feedback, please let us know. ", -1)]))]),
        _: 1
      }, 8, ["onClick:close"]), canViewOldVersion.value ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: "text-gray-500 cursor-pointer",
        onClick: viewOldVersion
      }, " View old version ")) : _createCommentVNode("", true)]), _createVNode(MetabaseDashboard, {
        dashboardId: insightState.dashboardId,
        alerts: props.alerts,
        minHeight: '361px',
        class: "flex-1"
      }, null, 8, ["dashboardId", "alerts"])])) : insightState && !insightState.loading && insightState.keys && insightState.dashboardId && !insightState.isTimeEntryPage && insightState.provider !== 'metabase' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [insightState.warning ? (_openBlock(), _createBlock(_component_v_alert, {
        key: 0,
        type: "warning",
        variant: "tonal",
        density: "compact",
        "onClick:close": _ctx.dismissBanner,
        class: "text-sm flex-1"
      }, {
        text: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" This version of the report will be unavailable after 7/31/2026. Please use the newer verison, or let us know if you are experiencing any issues. ", -1)]))]),
        _: 1
      }, 8, ["onClick:close"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createVNode(_component_luzmo_dashboard, {
        class: "overflow-y-scroll",
        ref_key: "dashboardInstance",
        ref: dashboardInstance,
        dashboardId: insightState.dashboardId,
        language: 'en',
        authKey: insightState.keys.authKey,
        authToken: insightState.keys.authToken,
        appServer: appServer,
        apiHost: apiHost,
        mainColor: "rgb(41, 191, 18)",
        accentColor: "rgb(240, 146, 51)",
        loaderBackground: "rgb(244, 244, 244)",
        loaderSpinnerColor: "rgb(42, 152, 17)",
        loaderSpinnerBackground: "rgb(201, 197, 202)",
        editMode: insightState.editMode,
        onDashboardAction: updateDashboardTitle
      }, null, 8, ["dashboardId", "authKey", "authToken", "editMode"])])])) : insightState.isTimeEntryPage && insightState.provider === 'metabase' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(MetabaseDashboard, {
        dashboardId: insightState.timeEntryDashboardId,
        filters: metabaseFilters.value,
        alerts: props.alerts
      }, null, 8, ["dashboardId", "filters", "alerts"])])) : insightState.isTimeEntryPage && insightState.provider === 'luzmo' && insightState.keys && !insightState.loading && insightState.timeEntryDashboardId?.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_luzmo_dashboard, {
        class: "overflow-y-scroll",
        ref_key: "dashboardInstance",
        ref: dashboardInstance,
        timezoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
        dashboardId: insightState.timeEntryDashboardId,
        language: 'en',
        authKey: insightState.keys.authKey,
        authToken: insightState.keys.authToken,
        appServer: appServer,
        apiHost: apiHost,
        mainColor: "rgb(41, 191, 18)",
        accentColor: "rgb(240, 146, 51)",
        loaderBackground: "rgb(244, 244, 244)",
        loaderSpinnerColor: "rgb(42, 152, 17)",
        loaderSpinnerBackground: "rgb(201, 197, 202)"
      }, null, 8, ["timezoneId", "dashboardId", "authKey", "authToken"])])])) : _createCommentVNode("", true);
    };
  }
};